<template>
<header class="header">
      <nav class="navbar">
        <div class="logo">
          <router-link to="/" style="text-decoration: none" class=" text-white ff-t3">Mia
            </router-link>
        
        </div>

        <!-- Boutons qui apparaissent au scroll -->
        <div v-if="showScrollButtons" class="scroll-buttons">
          <router-link to="/contact" style="text-decoration: none" class="btn btn-small ffv">Réserver</router-link>
          <router-link to="/carte" style="text-decoration: none" class="btn btn-small ffv">La Carte</router-link>
        </div>

        <ul class="nav-menu" :class="{ active: mobileMenuOpen }">
          
          <li><router-link to="/" style="text-decoration: none" class=" ffv">Accueil
            </router-link></li>
          <li>
            <router-link to="/carte" style="text-decoration: none" class=" ffv">La Carte
            </router-link>
          </li>
          <li>
            <a href="#apropos" style="text-decoration: none" @click="navigateToSection('apropos')">À Propos</a></li>
          <li>
            <a href="#avis" style="text-decoration: none" @click="navigateToSection('avis')">Avis</a></li>
          <li> <router-link to="/contact" style="text-decoration: none" class=" contact-button">Contact
            </router-link></li>
          <li>
            <a href="#" class="instagram-icon">
              <!-- SVG conservé tel quel -->
              <slot name="instagram-icon" />
            </a>
          </li>
          <li>
            <a  class="cursor-pointer" href="https://www.instagram.com/mia_grenoble/?hl=fr" target="_blank" rel="noopener noreferrer">
              <svg width="42px" height="42px" viewBox="0 -0.5 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="24" fill="#ea3531" />

                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M15.5 5H9.5C7.29086 5 5.5 6.79086 5.5 9V15C5.5 17.2091 7.29086 19 9.5 19H15.5C17.7091 19 19.5 17.2091 19.5 15V9C19.5 6.79086 17.7091 5 15.5 5Z"
                  stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.5 15C10.8431 15 9.5 13.6569 9.5 12C9.5 10.3431 10.8431 9 12.5 9C14.1569 9 15.5 10.3431 15.5 12C15.5 12.7956 15.1839 13.5587 14.6213 14.1213C14.0587 14.6839 13.2956 15 12.5 15Z"
                  stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <rect x="15.5" y="9" width="2" height="2" rx="1" transform="rotate(-90 15.5 9)" fill="#ffffff" />
                <rect x="16" y="8.5" width="1" height="1" rx="0.5" transform="rotate(-90 16 8.5)" stroke="#ffffff"
                  stroke-linecap="round" />
              </svg>
            </a></li>
        </ul> 

        <div class="hamburger" :class="{ active: mobileMenuOpen }" @click="toggleMobileMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>
    </header>
</template>

<script>

export default {
  name: "AppHeader",
  components: {
    
  },
  data() {
    return {
      isScrolled: false,
      isMobile: false,
      showSubMenu: false,
      mobileMenuOpen: false,
      showScrollButtons: false,
    };
  },
  computed: {
    isInformationsPage() {
      return this.$route.path === "/";
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.innerWidth <= 668 ? (this.isMobile = true) : (this.isMobile = false);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    scrollToSection(sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    },
    navigateToSection(sectionId) {
      this.closeMobileMenu();
      if (this.$route.path === "/") {
        this.scrollToSection(sectionId);
      } else {
        this.$router.push({ path: "/", hash: `#${sectionId}` });
        setTimeout(() => {
          this.scrollToSection(sectionId);
        }, 500);
      }
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    },
    handleScroll() {
      //this.isScrolled = window.scrollY > 500;
      // Afficher les boutons après 300px de scroll
      this.showScrollButtons = window.scrollY > 300;
    },
        toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
  },
};
</script>

<style scoped>
.navbar {
  transition: all 0.3s ease;
}

.scroll-buttons {
  display: none;
  gap: 10px;
  opacity: 0;
  animation: slideDown 0.3s ease forwards;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.scroll-buttons .btn-small {
  padding: 8px 16px;
  font-size: 0.85rem;
  background-color: #ea3531;
  color: white;
  border: 1px solid #ea3531;
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.scroll-buttons .btn-small:hover {
  background-color: white;
  color: #ea3531;
  border-color: white;
}

@media (max-width: 768px) {
  .scroll-buttons {
    display: flex;
    
  }
}

.instagram-float-btn {
  position: fixed;
  left: 20px;
  top: 15vh; /* 1/3 de la hauteur de l'écran */
  z-index: 1001;
  background-color: #E1306C; /* Couleur Instagram */
  color: white;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  transition: all 0.3s ease;
}

.instagram-float-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0,0,0,0.3);
}

.instagram-float-btn i {
  font-size: 24px;
}

.navbar.scrolled {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 70px;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background: #ed2f2d !important;
}

.dropdown {
  position: relative;
}
</style>